import React, { FC } from 'react'
import IComponentProps from 'interfaces/IComponentProps';
import { useHistory } from 'react-router-dom';
import Modal from 'components/Modal';
import Frame from 'components/Frame';
import Login from 'models/Login';
import { inject, observer } from 'mobx-react';

interface IContinuePTProps extends IComponentProps {
  loginInfo?: Login;
}

const ContinuePT: FC<IContinuePTProps> = ({loginInfo = new Login()}) => {
  const history = useHistory();
  const nextClick = async () => {
    await loginInfo.updateNow();
    if(!loginInfo.ptCountCheck)
      return;
    else
      history.replace('/presentation');
  }
  return (
    <Frame className='bg'>
      <Modal
        open={true}
      >
        <div>
          {`PT 면접 진행 도중 종료되었습니다.\n응시기회는 최대 3번까지만 허용되는 점 유의하세요.\n마지막으로 진행하고 있던 화면으로 이동합니다.`}
        </div>
        <button
          className='btn-cta'
          onClick={()=>nextClick()}
        >
          확인
        </button>
      </Modal>
    </Frame>
  )
}

export default inject('loginInfo')(observer(ContinuePT));